
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.profile-page-wrapper{
  margin-bottom:var(--spacing-12);
}

.name{
  margin-bottom:var(--spacing-3);
}

@media (min-width: 768px){

.details-wrapper{
    display:flex;
    justify-content:space-between;
    gap:10%
}
  }

.image-placeholder img{
  max-width:100%;
  height:auto;
}

.title,
.department{
  color:var(--brand-primary-dark-blue);
  font-family:var(--ff-display);
}

.department{
  font-size:var(--fs-body-lg);
}

.personal-info-wrapper{
  margin-bottom:var(--spacing-4);
}

.detail-contact,
.detail-location{
  font-size:var(--fs-body-sm);
}

@media (min-width: 768px){

.detail-contact,
.detail-location{
    width:50%
}
  }

.detail{
  display:flex;
  gap:var(--spacing-4);
  padding:var(--spacing-2) 0;
  font-family:var(--ff-body);
}

.detail .label{
    color:var(--brand-gray-90);
    font-family:var(--ff-display);
    width:40%;
    min-width:40%;
  }

.detail a{
    text-decoration:underline;
    color:var(--brand-primary-dark-blue);
    transition:0.3s ease all;
  }

.detail a:hover,
  .detail a:focus{
    outline:none;
    color:var(--brand-primary-dark-blue);
    background-color:var(--brand-primary-green);
  }

.detail a:focus{
    border-top:1px solid var(--brand-primary-dark-blue);
    border-bottom:1px solid var(--brand-primary-dark-blue);
  }
`;